import moment from "moment";

// ids of each of the endpoints is the elemental block ID
export const coinTossEndpoint = (id) => `/api/submission/${id}/coin-toss`
export const kidsTakeoverEndpoint = (id) => `/api/submission/${id}/kids-takeover`
export const cricketGrantEndpoint = (id) => `/api/submission/${id}/cricket-grant`
export const contactUsEndpoint = (id) => `/api/submission/${id}/contact-us`
export const getMatchLocationsEndpoint = `/api/matches/locations`

const requestHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest'
}

export const handleFormSubmit = (values, endpoint) => fetch(endpoint, {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify({...values}, null, 2),
    }
).then((res) => res.json());

export const handleFetch = (endpoint) => fetch(endpoint, {
        method: 'GET',
        headers: requestHeaders,
    }
).then((res) => res.json());

export const getNominateMatchOptions = () => handleFetch(getMatchLocationsEndpoint)
    .then((response) => {
            return response?.map((item) => {
                const val = `${moment(item.EventDate).format('ddd D MMM')} ${item.Location}`

                return {
                    value: val,
                    label: val
                }
            })
        }
    )

